import * as moment from 'moment';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  Database,
  child,
  getDatabase,
  get as getFire,
  onValue,
  push,
  ref,
  set,
  update,
} from 'firebase/database';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { find, get } from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { Breadcrumb } from '@models/layout/breadcrumb.model';
import { BuiltLocalRoom } from '@models/commutiny-chat/built-local-room.model';
import { ChatRoom } from '@models/commutiny-chat/chat-room.model';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Community } from '@models/communities/community.model';
import { Corporation } from '@models/corporations/corporation.model';
import { Files } from '@models/commutiny-chat/single-message-room.model';
import { FilterRoomsPipe } from 'src/app/core/pipes/filter.pipe';
import { LastMessage } from '@models/commutiny-chat/last-message.model';
import { Lightbox } from 'ngx-lightbox';
import { LoadRoom } from '@models/commutiny-chat/load-room.model';
import { MessageThread } from '@models/commutiny-chat/message-thread.model';
import { MessagesRoom } from '@models/commutiny-chat/messages-room.model';
import { RoomBackup } from '@models/commutiny-chat/rooms-backup.model';
import { SingleMessageRoom } from '@models/commutiny-chat/single-message-room.model';
import { UnReadMessagesAmount } from '@models/commutiny-chat/unread-messages-amount.model';
import { UnreadMessages } from '@models/commutiny-chat/messages-room.model';
import { User } from '@models/account/user.model';
import { UserRoom } from '@models/commutiny-chat/user-room.model';
import { environment } from '@environments/environment';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: [
    './chat.component.scss',
    '../../../../node_modules/@ctrl/ngx-emoji-mart/picker.css', //node_modules/@ctrl/ngx-emoji-mart/picker.css
  ],
  providers: [CommonVerbsApiService, FilterRoomsPipe],
})
export class ChatComponent implements OnInit {
  @ViewChild('scrollEle') scrollEle: any;
  @ViewChild('scrollRef') scrollRef: any;

  username = ''; //receptor
  senderName = ''; //sender

  api: CommonVerbsApiService;

  // bread crumb items
  breadCrumbItems: Breadcrumb[] = [];

  formData!: FormGroup;
  // Form submit
  chatSubmit: boolean | undefined;
  usermessage: string | undefined;
  isEmoji = false;

  unReadMessages: UnreadMessages = {};

  user: User | null = null;
  userRoles: {
    id: string | null;
    name: string;
  }[] = [];
  currentUserId = '';
  currentUserNumericId: number | null = null;
  allowedToSend: boolean | undefined;

  initialParamenters: object = environment.firebaseConfig;
  currentCommunityId: string | null = null;
  currentCommunityNumericId = 0;
  currentCommunity: object = {};
  communities: object[] = [];
  corporationCommunitiesAux: Community[] = [];

  app: FirebaseApp;
  databaseFirebase: Database;
  basePathRooms = environment.basePathRooms;
  basePathUnreadStaff = environment.basePathUnreadStaff;

  rooms: BuiltLocalRoom[] = [];
  roomsFiltered: BuiltLocalRoom[] = [];
  roomsBackup: RoomBackup = {};
  loadRoom: LoadRoom = {};
  unReadMessagesAmount: UnReadMessagesAmount = {};
  messagesRoom: MessagesRoom = {};
  currentRoomId = '';
  currentRoomName = '';
  currentRoomRelationship = '';
  currentRoomAvatar = 'assets/images/users/avatarv2.jpg';
  messages: SingleMessageRoom[] = [];
  sortedMessages: { date: string; Belongmessages: SingleMessageRoom[] }[] = [];
  messagesLoaded = false;
  loadingRooms = false;
  isSorted = false;

  isEmojiPickerVisible = false;
  searchText = '';
  fileToUpload: File | null = null;
  sendLoading = false;

  page = 1;
  pageSize = 10;
  paginationCounter = 0;
  msgGroup = [
    { id: 1, name: 'All Messages' },
    { id: 2, name: 'Resident Messages' },
    { id: 3, name: 'Family Messages' },
  ];

  residentName?: string;
  residentCurrentId?: string;
  residentCurrentIds: {
    oldId: string | number;
    currentId: string;
  }[] = [];

  msgGroupSelected = 1;
  lastImage: string | null = null;

  constructor(
    private _lightbox: Lightbox,
    private activeRoute: ActivatedRoute,
    public formBuilder: FormBuilder,
    api: CommonVerbsApiService,
    private roomsPipe: FilterRoomsPipe
  ) {
    this.api = api;
    this.app = initializeApp(environment.firebaseConfig);
    this.databaseFirebase = getDatabase(this.app);
  }

  ngOnInit() {
    this.breadCrumbItems = [
      { label: 'Community Portal', route: `../analytics` },
      { label: 'Messages', active: true },
    ];

    this.formData = this.formBuilder.group({
      message: ['', [Validators.required]],
    });

    if (this.activeRoute.parent !== null) {
      this.activeRoute.parent.paramMap.subscribe(route => {
        if (route.has('id')) {
          this.currentCommunityId = route.get('id') ?? null;
          this.getCurrentCommunity();
        } else {
          this.initializeUser();
        }
      });
    }
    this.onListScroll();
  }

  handleFileInput(files: any) {
    this.fileToUpload = files.files.item(0);

    if (this.fileToUpload !== null) {
      this.formData.patchValue({
        message: this.fileToUpload,
      });

      const img_prev: HTMLImageElement | null =
        document.querySelector('#img_preview');
      const objectURL = URL.createObjectURL(this.fileToUpload);
      if (img_prev) {
        img_prev.src = objectURL;
      }
    } else {
      return;
    }
  }

  unselectImage() {
    this.formData.patchValue({
      message: '',
    });
  }

  showImagePreview() {
    const message = this.formData.get('message')?.value;
    if (Object.prototype.toString.call(message) === '[object File]') {
      return false;
    } else {
      return true;
    }
  }

  setFileChat() {
    const inputFile = document.getElementById(
      'fileMessage'
    ) as HTMLInputElement;
    if (inputFile) {
      inputFile.value = '';
    }
    inputFile.click();
  }

  addEmoji(event: any) {
    this.isEmoji = true;
    const message = this.formData.get('message')?.value;
    if (message !== null) {
      this.formData.patchValue({
        message: `${message}${event.emoji.native}`,
      });
    } else {
      this.formData.patchValue({
        message: `${event.emoji.native}`,
      });
    }
    // this.isEmojiPickerVisible = false;
  }

  lightboxImage(url: string, caption = '') {
    const src = url;
    const thumb = 'tumb';
    const album =
      caption === ''
        ? { src: src, thumb: thumb }
        : { src: src, caption: caption, thumb: thumb };
    const _albums = [];
    _albums.push(album);
    this._lightbox.open(_albums, 0);
  }

  initializeUser() {
    const tokenIdentifier = localStorage.getItem('tokenIdentifier');
    this.api
      .get<User>(`users/${tokenIdentifier}`, {}, [
        'communities',
        'relatives',
        'corporations',
      ])
      .subscribe(Response => {
        this.user = JSON.parse(JSON.stringify(Response));
        this.userRoles = Response.roles;
        this.currentUserNumericId = Response.oldUserId;
        if (
          this.userRoles.some(
            e => e.name === 'ADMIN' || 'COMMUNITY_ADMIN' || 'CORPORATION_ADMIN'
          )
        ) {
          this.allowedToSend = true;
        }
        this.senderName = Response.name ?? '';
        this.currentUserId = Response.id;

        const isSysAdmin = this.userRoles.some(
          e => e.name === 'ADMIN' || 'COMMUNITY_ADMIN' || 'CORPORATION_ADMIN'
        )
          ? true
          : false;
        let isCorporationAdmin = false;
        let hascommunities = false;
        if (Response.corporations !== null) {
          if (Response.corporations.length > 0) {
            isCorporationAdmin = true;
          }
        }
        if (this.currentCommunityId !== null) {
          const communityId = this.currentCommunityId;

          const communitiesArray = JSON.parse(
            JSON.stringify(Object.values(Response.communities))
          );
          for (const index in communitiesArray) {
            if (get(communitiesArray[index], 'id', [null]) === communityId) {
              hascommunities = true;
            }
          }
          if (isCorporationAdmin) {
            this.api
              .get<Corporation>(
                `corporations/${Response.corporations[0].id}`,
                {},
                ['communities']
              )
              .subscribe(Response => {
                this.corporationCommunitiesAux = Response.communities;
                const communitiesArrayCorporation = JSON.parse(
                  JSON.stringify(Object.values(Response.communities))
                );

                for (const index in communitiesArrayCorporation) {
                  if (
                    get(communitiesArrayCorporation[index], 'id', [null]) ===
                    communityId
                  ) {
                    hascommunities = true;
                  }
                }
              });
          }
          if (isSysAdmin) {
            hascommunities = true;
          }
          this.communities = [this.currentCommunity];
        } else if (isCorporationAdmin) {
          this.api
            .get<Corporation>(
              `corporations/${Response.corporations[0].id}`,
              {},
              ['communities']
            )
            .subscribe(ResponseCor => {
              hascommunities = true;
              this.communities = ResponseCor.communities;
            });
        }
        setTimeout(() => {
          if (hascommunities || isSysAdmin) {
            this.setRooms();
          }
        }, 500);
      });
  }

  getCurrentCommunity() {
    this.api
      .get<Community>(`communities/${this.currentCommunityId}`)
      .subscribe(Response => {
        this.currentCommunity = Response;
        this.currentCommunityNumericId = Response.oldCommunityId;
        this.initializeUser();
      });
  }

  parseMessage(message: string, username: string) {
    const subString = '```' + username + '```';
    return message.replace(subString, '');
  }

  async setRooms() {
    let countIterations = 0;
    const roomsAux: object[] = [];
    const aux = JSON.parse(JSON.stringify(this.communities));
    let communityId;
    let path1 = '';
    path1 = path1.concat(
      this.basePathUnreadStaff,
      this.currentUserNumericId?.toString() ?? ''
    );

    const ref_unread = ref(this.databaseFirebase);
    getFire(child(ref_unread, path1)).then(snapshot => {
      const data = snapshot.val();
      this.unReadMessages = JSON.parse(JSON.stringify(data));
      for (const content in aux) {
        const path =
          'chat_personal_inbox/' + get(aux[content], 'oldCommunityId', [null]);
        const ref_inbox = ref(this.databaseFirebase);
        getFire(child(ref_inbox, path)).then(snapshot => {
          const messages2: ChatRoom = snapshot.val();
          for (const index in messages2) {
            try {
              communityId = aux[content].oldCommunityId;
              const newRooms = this.getResidentsPerRelative(
                messages2,
                index,
                communityId,
                path
              );
              if (newRooms.length > 0) {
                for (const newRoom in newRooms) {
                  if (
                    find(roomsAux, { roomId: newRooms[newRoom].roomId }) ===
                    undefined
                  ) {
                    roomsAux.push(newRooms[newRoom]);
                    this.rooms.push(newRooms[newRoom]);
                    this.addMessagesLoad(true, newRooms[newRoom].roomId);
                  }
                }
              } else {
                const pathLastMessage = path.concat('/', index.toString());
                let roomid = 'chat_';
                this.roomsBackup[pathLastMessage] = messages2[index];
                const user = messages2[index].user;
                const room = user.name;
                roomid = roomid.concat(
                  communityId,
                  '_',
                  user.resident.id.toString(),
                  '_',
                  index.toString()
                );
                this.loadRoom[roomid] = true;

                const unReadCount = messages2[index]?.unread
                  ? messages2[index].unread
                  : 0;
                this.unReadMessagesAmount[roomid] = unReadCount;

                let totalRoom = {
                  index: messages2[index].createdAt,
                  roomId: roomid,
                  roomName: room,
                  lastMessage: {
                    content: '',
                    senderId: 0,
                    username: '',
                    timestamp: '',
                    saved: false,
                    distributed: false,
                    seen: false,
                    new: false,
                  },
                  unreadCount: unReadCount,
                  users: [
                    {
                      _id: user.resident.id,
                      username: user.name,
                      avatar: 'assets/images/users/avatarv2.jpg',
                      photoLoaded: false,
                      status: {
                        state: 'offline',
                        lastChanged: ' ',
                      },
                    },
                    {
                      _id: this.user?.oldUserId ?? 0,
                      username: this.senderName,
                      avatar: 'assets/images/users/avatarv2.jpg',
                      photoLoaded: false,
                      status: {
                        state: 'offline',
                        lastChanged: ' ',
                      },
                    },
                  ],
                };

                if (user.relationship) {
                  totalRoom = Object.assign(
                    {
                      relationship: user.relationship,
                      residentName: user.resident.name,
                      residentId: user.resident.id,
                    },
                    totalRoom
                  );
                }

                if (find(roomsAux, { roomId: roomid }) === undefined) {
                  roomsAux.push(totalRoom);
                  this.rooms.push(totalRoom);
                  this.addMessagesLoad(true, roomid).then(() => {
                    countIterations++;
                    if (Object.keys(messages2).length === countIterations) {
                      this.sortRoomsByIndex();
                    }
                  });
                }
              }
            } catch (error) {
              countIterations++;
              if (Object.keys(messages2).length === countIterations) {
                this.sortRoomsByIndex();
              }
              /* console.error(error); */
            }
          }
        });
      }
    });
    setTimeout(() => {
      this.roomsFilter('ALL');
    }, 3000);
  }

  async addMessagesLoad(reset: boolean, roomId: string) {
    let messages = [];
    let path = 'chat_personal/';
    path = path.concat(roomId.toString());
    const loadRoom = this.loadRoom[roomId];
    if (loadRoom) {
      const ref_unread = ref(this.databaseFirebase, path);
      onValue(ref_unread, snapshot => {
        try {
          const pathRoom = path.substring(14, path.length);
          const aux = snapshot.val();
          let deletea = true;
          let length = 0;
          let lengthMessages = 0;
          try {
            length = Object.keys(aux).length;
            lengthMessages = this.messagesRoom[roomId].length;
            deletea = length < lengthMessages;
          } catch (error) {
            /* console.error(error); */
          }

          if (this.loadRoom[roomId] || deletea) {
            this.loadRoom[roomId] = false;
            this.messagesRoom[roomId] = [];
            messages = [];
            let lastTimeRead = 0;
            if (this.unReadMessages === null) {
              this.setUnreadMessages(this.currentUserNumericId ?? 0, roomId, 0);
            } else if (
              roomId in this.unReadMessages &&
              get(this.unReadMessages[roomId], 'lastRead', false)
            ) {
              lastTimeRead = this.unReadMessages[roomId].lastRead;
            }
            let countUnReadMessages = 0;
            for (const index in aux) {
              const lastMessage = this.setUniquiMessage(
                aux[index],
                index
                // roomId
              );
              if (lastMessage !== null) {
                const timeMessage = aux[index].createdAt;
                if (timeMessage > lastTimeRead) {
                  countUnReadMessages++;
                }
                messages.push(lastMessage);
              }
            }
            this.unReadMessagesAmount[roomId] = countUnReadMessages;
            if (this.currentRoomId === pathRoom) {
              this.messages = messages;
            }
            this.messagesRoom[roomId] = messages;
            this.setLastMessage(
              roomId,
              aux[Object.keys(aux)[Object.keys(aux).length - 1]],
              false,
              false
            );
          } else {
            try {
              // add new message to room
              if (length > lengthMessages) {
                const idKey = Object.keys(aux)[Object.keys(aux).length - 1];
                const lastmessage =
                  aux[Object.keys(aux)[Object.keys(aux).length - 1]];
                const addMessage = this.setUniquiMessage(lastmessage, idKey);
                if (addMessage !== null) {
                  this.messagesRoom[roomId].push(addMessage);
                  if (addMessage.senderId !== this.currentUserNumericId) {
                    this.showAlertNewMessage(addMessage);
                  }
                }
                if (this.currentRoomId === pathRoom) {
                  this.messages = this.messagesRoom[roomId];
                  this.setRoomOnTop(roomId, true, lastmessage);
                  const time = Date.now();
                  this.setUnreadMessages(
                    this.currentUserNumericId ?? 0,
                    this.currentRoomId,
                    time
                  ).then(() => {
                    this.sortMessagesByRoom();
                    this.sortRoomsByIndex();
                  });
                } else {
                  this.setRoomOnTop(roomId, false, lastmessage).then(() => {
                    this.sortMessagesByRoom();
                    this.sortRoomsByIndex();
                  });
                }
              }
            } catch (error) {
              /* console.error(error); */
            }
          }
        } catch (error) {
          messages = [];
          this.messages = [];
        }
      });
    } else {
      const messagesRoom = this.messagesRoom[roomId];
      setTimeout(() => {
        this.messages = messagesRoom;
        this.messagesLoaded = true;
      });
    }
    return false;
  }

  async setRoomOnTop(
    roomId: string,
    isSame: boolean,
    lastmessage: LastMessage
  ) {
    await this.rooms.findIndex((value, index) => {
      if (value.roomId === roomId) {
        const aux = value;
        aux.index = Date.now();
        if (isSame) {
          aux.unreadCount = 0;
        } else {
          aux.unreadCount++;
        }
        const datetime = moment.default(Date.now()).format('LT');
        aux.lastMessage.content = lastmessage.text;
        aux.lastMessage.username = '';
        aux.lastMessage.senderId = 15352;
        aux.lastMessage.senderId = this.user?.oldUserId ?? 0;
        aux.lastMessage.timestamp = datetime;
        (aux.users = [aux.users[0], aux.users[1]]),
          setTimeout(() => {
            this.rooms[index] = aux;
          });

        return index;
      }
      return null;
    });
  }

  setUniquiMessage(message: LastMessage, index: string) {
    let isSystem = false;
    let sender = 0;
    let user = '';
    if (get(message, 'system', false)) {
      sender = this.user?.oldUserId ?? 0;
      isSystem = true;
    } else {
      isSystem = false;
      try {
        sender = message.user._id;
        user = message.user.name;
      } catch (error) {
        sender = 0;
      }
    }
    try {
      const dateStr = new Date(message.createdAt).toDateString();
      const timestamp = moment.default(message.createdAt).format('LTS');
      const thisMessage = {
        _id: index,
        senderId: sender,
        username: user,
        date: dateStr,
        timestamp: timestamp,
        system: isSystem,
        content: '',
        files: {},
      };
      if (get(message, 'messageType', false)) {
        const image = this.setImage(message);
        const textMessage = get(message, 'text', '');
        image
          .then(value => {
            thisMessage.files = value as object;
            thisMessage.content = '```' + user + '```' + textMessage;
            return thisMessage;
          })
          .catch(() => null);
      }
      if (get(message, 'text', false)) {
        if (!isSystem) {
          thisMessage.content = '```' + user + '```' + message.text;
        } else {
          thisMessage.content = message.text;
        }
      } else {
        thisMessage.content = '';
      }
      return thisMessage;
    } catch (error) {
      return null;
    }
  }

  async setImage(image: LastMessage) {
    return new Promise((resolve, reject) => {
      const imageUrl = image?.image || 'assets/images/empty-image-bg.png';

      if (image.messageType === 'image') {
        resolve([
          {
            name: 'My File',
            type: 'png',
            audio: false,
            url: imageUrl,
          },
        ]);
      } else {
        reject(false);
      }
    });
  }

  setLastMessage(
    roomId: string,
    message: LastMessage,
    refresh: boolean,
    increment: boolean
  ) {
    let unReadMessages = this.unReadMessagesAmount[roomId];
    if (increment) {
      unReadMessages = unReadMessages++;
      this.unReadMessagesAmount[roomId] = unReadMessages;
    }
    this.loadingRooms = true;
    let datetime = '';
    if (
      moment.default().format('L') ===
      moment.default(message.createdAt).format('L')
    ) {
      datetime = moment.default(message.createdAt).format('LT');
    } else {
      datetime = moment.default(message.createdAt).format('MMM Do YY');
    }
    const textlast = message?.text ? message.text : '';
    const lastMessage = {
      content: textlast,
      senderId: 1232334,
      username: 'John Doe2',
      timestamp: datetime,
      saved: true,
      distributed: true,
      seen: false,
      new: true,
    };

    this.rooms.findIndex((value, index) => {
      if (value.roomId === roomId) {
        const aux = value;
        aux.lastMessage = lastMessage;
        aux.unreadCount = unReadMessages;
        this.rooms[index] = aux;
        return index;
      }
      return null;
    });
    if (refresh) {
      const roomsAux2 = this.rooms;
      this.rooms = [...roomsAux2];
      setTimeout(() => {
        this.rooms = roomsAux2;
      }, 5000);
    }
    this.loadingRooms = false;
  }

  async setUnreadMessages(userID: number, roomId: string, lastRead: number) {
    interface lastMessageIn {
      lastRead: number;
    }
    const lastMessage: lastMessageIn = { lastRead: lastRead };
    const path = this.basePathUnreadStaff + userID + '/' + roomId;
    lastMessage.lastRead = lastRead;
    await set(ref(this.databaseFirebase, path), lastMessage);
  }

  getResidentsPerRelative(
    jsonRoomOriginal: ChatRoom,
    index: string,
    communityId: number,
    path: string
  ) {
    const roomsAux: any = [];
    const jsonRoom: any = jsonRoomOriginal[index];

    for (const index2 in jsonRoom) {
      try {
        const user = get(jsonRoom, '[' + index2 + '].user', null);
        const pathLastMessage =
          path + '/' + index.toString() + '/' + index2.toString();
        this.roomsBackup[pathLastMessage] =
          jsonRoom[index2 as keyof typeof jsonRoom];
        if (user !== null) {
          const room = this.getTotalRoom(user, index2, communityId);

          if (room) {
            this.loadRoom[room.roomId] = true;
          }

          const unReadCount = jsonRoom[index2]?.unread
            ? jsonRoom[index2].unread
            : 0;

          let totalRoom = {
            index: jsonRoom[index2].createdAt,
            roomId: room?.roomId ?? '',
            roomName: room?.roomName ?? '',
            lastMessage: {
              content: '',
              senderId: 0,
              username: '',
              timestamp: '',
              saved: false,
              distributed: false,
              seen: false,
              new: false,
            },
            unreadCount: unReadCount,
            users: [
              {
                _id: user.resident.id,
                username: user.name,
                avatar: 'assets/images/users/avatarv2.jpg',
                photoLoaded: false,
                status: {
                  state: 'offline',
                  lastChanged: ' ',
                },
              },
              {
                _id: this.user?.oldUserId ?? 0,
                username: this.senderName,
                avatar: 'assets/images/users/avatarv2.jpg',
                photoLoaded: false,
                status: {
                  state: 'offline',
                  lastChanged: ' ',
                },
              },
            ],
          };

          if (room?.relationship) {
            totalRoom = Object.assign(
              {
                relationship: room?.relationship,
                residentName: room?.residentName,
                residentId: room?.residentId,
              },
              totalRoom
            );
          }

          roomsAux.push(totalRoom);
        }
      } catch (error) {
        /* console.log(error); */
      }
    }
    return roomsAux;
  }

  getTotalRoom(user: UserRoom, userId: string, communityId: number) {
    try {
      let roomid = 'chat_';
      const room = user.name;
      roomid =
        roomid +
        communityId +
        '_' +
        user.resident.id.toString() +
        '_' +
        user._id.toString();

      if (user.relationship)
        return {
          roomId: roomid,
          roomName: room,
          relationship: user.relationship,
          residentName: user.resident.name,
          residentId: user.resident.id,
        };
      return { roomId: roomid, roomName: room };
    } catch (error) {
      return null;
    }
  }

  validateEmptyMessage(message: string | File) {
    if (Object.prototype.toString.call(message) === '[object File]') {
      return true;
    } else if (Object.prototype.toString.call(message) === '[object String]') {
      const auxMessage: string = message as string;
      if (auxMessage.trim() !== '') {
        return true;
      } else {
        return false;
      }
    } else {
      return;
    }
  }

  showAlertNewMessage(messageData: any) {
    if ('Notification' in window) {
      const bodyFormated = messageData.content.match(/```(.*)```(.*)/);

      let sender = '';
      let body = '';
      if (bodyFormated) {
        sender = bodyFormated[1];
        body = bodyFormated[2];
      } else {
        sender = messageData.username;
      }

      if (Notification.permission === 'granted') {
        const notification = new Notification(`New Message From ${sender}`, {
          body: body === '' ? 'Image' : body,
          icon: 'https://tsolife.com/assets/images/brands/tsolife-ico-250x250.svg',
        });
        notification.onclick = function () {
          notification.close();
        };
      } else {
        Notification.requestPermission().then(function (permission) {
          if (permission === 'granted') {
            const notification = new Notification(
              `New Message From ${sender}`,
              {
                body: body === '' ? 'Image' : body,
                icon: 'https://tsolife.com/assets/images/brands/tsolife-ico-250x250.svg',
              }
            );
            notification.onclick = function () {
              notification.close();
            };
          }
        });
      }
    }
  }

  async sendMessage() {
    const messageForm = this.formData.get('message')?.value;
    if (
      this.formData.valid &&
      messageForm &&
      this.validateEmptyMessage(messageForm)
    ) {
      const roomId = this.currentRoomId;
      let content = typeof messageForm === 'string' ? messageForm : 'Image';
      const userId = roomId.match(/.*_(.*)_*/);
      if (userId) {
        const messagePush = { body: content, userId: userId[1] };
        this.api
          .post('communities/send-push-notifications', messagePush)
          .subscribe();
      }

      if (typeof messageForm === 'object') {
        this.sendLoading = true;
        const params = {
          file: this.fileToUpload,
          source: 'UNKNOWN',
        };

        this.api.form<any>('media/upload', params).subscribe(result => {
          const urlImage = result[0].url;
          this.sendImage(urlImage, roomId);
          this.sendLoading = false;
        });
      }
      let path = 'chat_personal/';
      path = path.concat(roomId.toString());

      const user = {
        _id: this.user?.oldUserId,
        name: this.senderName,
        role: 'community_admin',
      };
      const message = {
        _id: uuidv4(),
        text: content,
        createdAt: Date.now(),
        user: user,
      };
      if (!(typeof messageForm === 'object' && content === 'Image')) {
        content = '_Image_';
        push(ref(this.databaseFirebase, path), message);
        this.pushLastMessage(user, message, roomId);
      }
      this.isEmojiPickerVisible = false;
      this.isEmoji = false;
    }
  }

  pushLastMessage(
    user: { _id: number | undefined; name: string; role: string },
    message: {
      _id: string | undefined;
      text: string;
      createdAt: number;
      user: { _id: number | undefined; name: string; role: string };
    },
    roomId: string
  ) {
    const first = roomId.indexOf('_');
    const second = roomId.indexOf('_', first + 1);
    const third = roomId.indexOf('_', second + 1);
    const communityId = roomId.substring(first + 1, second);
    const userId = roomId.substring(third + 1, roomId.length);
    const path = this.basePathRooms.concat(communityId, '/', userId);
    const lastMessage = this.roomsBackup[path];
    if (lastMessage) {
      (<RoomBackup>lastMessage).text = message.text;
      (<RoomBackup>lastMessage).createdAt = message.createdAt;
      (<RoomBackup>lastMessage).unread =
        ((<RoomBackup>lastMessage).unread as number) + 1;
      update(ref(this.databaseFirebase, path), lastMessage as object);
    }

    this.onListScroll();

    // Set Form Data Reset
    this.formData = this.formBuilder.group({
      message: null,
    });
    const currentRoom = this.rooms.find(room => room.roomId === roomId);
    if (currentRoom) {
      this.chatUsername(currentRoom);
    }
    this.chatSubmit = true;
  }

  async sendImage(url: string, roomId: string) {
    let path = 'chat_personal/';
    path = path.concat(roomId.toString());

    const user = {
      _id: this.user?.oldUserId,
      name: this.senderName,
      role: 'community_admin',
    };
    const message = {
      _id: uuidv4(),
      image: url,
      text: '',
      messageType: 'image',
      createdAt: Date.now(),
      user: user,
    };
    push(ref(this.databaseFirebase, path), message);
    this.pushLastMessage(user, message, roomId);
  }

  deleteMessage(message: SingleMessageRoom, roomId: string) {
    let path = 'chat_personal/';
    path = path.concat(roomId.toString(), '/', message._id);

    //remove(ref(this.databaseFirebase, path));
    const currentRoom = this.rooms.find(room => room.roomId === roomId);
    if (currentRoom) {
      this.chatUsername(currentRoom);
    }
  }

  get form() {
    return this.formData.controls;
  }

  onListScroll() {
    if (this.scrollRef !== undefined) {
      setTimeout(() => {
        this.scrollRef.SimpleBar.getScrollElement().scrollTop =
          this.scrollRef.SimpleBar.getScrollElement().scrollHeight + 1500;
      }, 500);
    }
  }

  chatUsername(room: BuiltLocalRoom) {
    if (this.currentRoomId !== '') {
      this.setRead(this.currentRoomId);
      this.sendReadMessage();
    }
    this.currentRoomId = room.roomId;

    if (room.roomId !== '') {
      this.sendReadMessage();
    }

    setTimeout(() => {
      this.messagesLoaded = false;

      this.loadRoomMessages(room.roomId);
      this.setRead(room.roomId);

      // Set Form Data Reset
      this.formData = this.formBuilder.group({
        message: null,
      });

      this.onListScroll();
      if (room.photoLoaded) {
        this.currentRoomAvatar =
          room.users[0].avatar ?? 'assets/images/users/avatarv2.jpg';
        this.residentCurrentId = this.residentCurrentIds.find(
          x => x.oldId === room.residentId
        )?.currentId;
      } else {
        this.loadRoomsImg([room]);
      }

      this.residentName = room.residentName ?? room.roomName;

      this.currentRoomName = room.roomName;
      this.currentRoomRelationship = room.relationship ? room.relationship : '';
    });
  }

  loadRoomMessages(roomId: string) {
    const messagesRoom = get(this.messagesRoom, roomId, null);
    setTimeout(() => {
      if (messagesRoom !== null) {
        this.messages = messagesRoom;
        this.sortMessagesByRoom();
        this.messagesLoaded = true;
      }
    });
  }

  sortRoomsByIndex() {
    this.rooms.sort((a, b) => {
      const dateA = new Date(a.index);
      const dateB = new Date(b.index);
      if (isNaN(dateA.getTime())) {
        return 1; // Invalid Dates At The End
      }
      if (isNaN(dateB.getTime())) {
        return -1; // Invalid Dates At The End
      }
      return dateB.getTime() - dateA.getTime();
    });
    this.onPageChange(true);
  }

  onPageChange(init = false) {
    let currentFilteredItems: BuiltLocalRoom[] = [];
    if (this.searchText) {
      currentFilteredItems = this.roomsPipe.transform(
        this.rooms,
        this.searchText
      );
    }
    let currentItems =
      currentFilteredItems.length > 0 ? currentFilteredItems : this.rooms;
    if (currentItems.length > 10) {
      if (!init) {
        this.page++;
      }
      const endIndex = (this.page - 1) * this.pageSize + this.pageSize;
      currentItems = currentItems.slice(this.paginationCounter * 10, endIndex);

      this.loadRoomsImg(currentItems);
      this.paginationCounter++;
    } else {
      this.loadRoomsImg(currentItems);
    }
  }

  loadRoomsImg(rooms: BuiltLocalRoom[]) {
    for (const i in rooms) {
      if (!rooms[i].photoLoaded) {
        const user = rooms[i].users[0];
        const originalIndex = this.rooms.findIndex(
          elem => elem.roomId === rooms[i].roomId
        );
        this.rooms[originalIndex].photoLoaded = true;
        if (typeof user._id === 'number' || !isNaN(Number(user._id))) {
          this.api
            .get<User>(`users/get-by-old-user-id/${user._id}`)
            .subscribe(Response => {
              const photo =
                Response.profile?.media?.url ??
                'assets/images/users/avatarv2.jpg';
              this.rooms[originalIndex].users[0].avatar = photo;
              rooms.length === 1 ? (this.currentRoomAvatar = photo) : null;
              this.residentCurrentIds.push({
                oldId: user._id,
                currentId: Response.id,
              });
              this.residentCurrentId = Response.id;
            });
        } else if (typeof user._id === 'string') {
          this.residentCurrentIds.push({
            oldId: user._id,
            currentId: user._id,
          });
          this.residentCurrentId = user._id;
          this.api.get<User>(`users/${user._id}`).subscribe(Response => {
            const photo =
              Response.profile?.media?.url ??
              'assets/images/users/avatarv2.jpg';
            this.rooms[originalIndex].users[0].avatar = photo;
            rooms.length === 1 ? (this.currentRoomAvatar = photo) : null;
          });
        } else {
          return;
        }
      }
    }
  }

  sortMessagesByRoom() {
    const groups: { [index: string]: SingleMessageRoom[] } =
      this.messages.reduce(
        (groups: { [index: string]: SingleMessageRoom[] }, message) => {
          const date = message.date;
          if (!groups[date]) {
            groups[date] = [];
          }
          groups[date].push(message);
          return groups;
        },
        {}
      );

    const groupArrays = Object.keys(groups).map(date => {
      return {
        date,
        Belongmessages: groups[date],
      };
    });

    this.sortedMessages = groupArrays;
  }

  sendReadMessage() {
    if (this.currentRoomId !== '') {
      const time = Date.now();
      this.setUnreadMessages(
        this.currentUserNumericId ?? 0,
        this.currentRoomId,
        time
      );
    }
  }

  setRead(roomId: string) {
    this.rooms.findIndex((value, index) => {
      if (value.roomId === roomId) {
        const aux = value;
        aux.unreadCount = 0;
        this.rooms[index] = aux;
        this.deleteUnReadMessage(roomId);
        return index;
      }
      return null;
    });
  }

  deleteUnReadMessage(roomId: string) {
    const first = roomId.indexOf('_');
    const second = roomId.indexOf('_', first + 1);
    const third = roomId.indexOf('_', second + 1);
    const communityId = roomId.substring(first + 1, second);
    const residentId = roomId.substring(second + 1, third);
    const userId = roomId.substring(third + 1, roomId.length);
    const path = this.basePathRooms.concat(communityId, '/', userId);
    let lastMessage = this.roomsBackup[path];
    if (lastMessage === undefined) {
      lastMessage = this.roomsBackup[path + '/' + residentId];
    }
    if (<RoomBackup>lastMessage) (<RoomBackup>lastMessage).unread = 0;
    update(ref(this.databaseFirebase, path), lastMessage as object);
  }

  showImageOrMessage(message: SingleMessageRoom) {
    if (Object.prototype.toString.call(message.files) === '[object Array]') {
      return true;
    } else {
      return false;
    }
  }

  returnImage(message: SingleMessageRoom) {
    if (Object.prototype.toString.call(message.files) === '[object Array]') {
      if (message.files) {
        const auxMessageImg: Files[] = message.files as Files[];
        return auxMessageImg[0].url;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  copyAction(text: string, username: string) {
    const subString = '```' + username + '```';
    const message = text.replace(subString, '');
    navigator.clipboard.writeText(message);
  }

  checkTime(time: string) {
    if (time) {
      if (time.includes('AM') || time.includes('PM')) {
        const currentDate = new Date();
        const dateTimeString = `${currentDate.toDateString()} ${time}`;
        const jsDate = new Date(dateTimeString);

        let diffInHours = moment
          .default(currentDate)
          .diff(moment.default(jsDate), 'hours');
        let timeUnit = 'h';

        if (diffInHours === 0) {
          diffInHours = moment
            .default(currentDate)
            .diff(moment.default(jsDate), 'minutes');
          timeUnit = 'm';
        }
        return `${diffInHours}${timeUnit}`;
      } else {
        return time;
      }
    }

    return '';
  }

  async roomsFilter(roomsType: string) {
    if (roomsType === 'ALL') this.roomsFiltered = this.rooms;
    if (roomsType === 'RESIDENT')
      this.roomsFiltered = this.rooms.filter(x => !x.relationship);
    if (roomsType === 'FAMILY')
      this.roomsFiltered = this.rooms.filter(x => x.relationship);

    await this.sortByDate();
    this.isSorted = true;
  }

  sortByDate(): Promise<void> {
    return new Promise(resolve => {
      this.roomsFiltered.sort((a, b) => {
        const today = moment.default().startOf('day');

        // If the timestamp is just the time, assume it's today; otherwise, use the date
        const dateA = a.lastMessage.timestamp.includes(':')
          ? today.clone().set({
              hour: moment.default(a.lastMessage.timestamp, 'HH:mm A').hour(),
              minute: moment
                .default(a.lastMessage.timestamp, 'HH:mm A')
                .minute(),
            })
          : moment.default(a.lastMessage.timestamp, 'MMM Do YY');

        const dateB = b.lastMessage.timestamp.includes(':')
          ? today.clone().set({
              hour: moment.default(b.lastMessage.timestamp, 'HH:mm A').hour(),
              minute: moment
                .default(b.lastMessage.timestamp, 'HH:mm A')
                .minute(),
            })
          : moment.default(b.lastMessage.timestamp, 'MMM Do YY');

        return dateB.diff(dateA);
      });

      resolve();
    });
  }

  onDownloadCSV() {
    const arrMsg: MessageThread[] = [];
    const label = `${this.currentRoomName}::msg:thread`;
    const options = {
      headers: [
        'Message To (Recipient)',
        'Recipient Type',
        'Relationship/Title',
        'Message From (Sender)',
        'Message Text',
        'Date & Time Delivered',
      ],
    };

    for (let i = 0; i < this.sortedMessages.length; i++) {
      this.sortedMessages[i].Belongmessages.map(x => {
        const dateDelivered = moment.default(x.date).format('MM/DD/YYYY');

        let message = this.parseMessage(x.content, x.username);
        if (!message && Array.isArray(x.files)) {
          x.files.forEach((f, j) => {
            message +=
              j === 0 ? `${f.name}.${f.type}` : `, ${f.name}.${f.type}`;
          });
        }

        arrMsg.push({
          sender: x.username,
          message: message,
          date: `${dateDelivered} ${x.timestamp}`,
        });
      });
    }

    const arrMsg2: MessageThread[] = [];

    for (let i = 1; i < arrMsg.length; i++) {
      const recipient = i === 1 ? 'System' : arrMsg[i - 1]?.sender;

      let recipientType = 'Community Admin';
      if (this.currentRoomRelationship && recipient === this.currentRoomName)
        recipientType = 'Family';
      if (recipient === 'System') recipientType = 'System';

      let relationship = 'Activity Staff';
      if (recipient === this.currentRoomName) {
        if (this.currentRoomRelationship) {
          relationship = `${this.currentRoomRelationship} of ${this.residentName}`;
        } else {
          relationship = 'Resident';
          recipientType = 'Resident';
        }
      }
      if (recipient === 'System') relationship = 'System';

      arrMsg2.push({
        recipient: recipient,
        recipientType: recipientType,
        relationship: relationship,
        sender: arrMsg[i].sender,
        message: arrMsg[i].message,
        date: arrMsg[i].date,
      });
    }

    new AngularCsv(arrMsg2, label, options);
  }

  compareImage(msg: number, currentImage: string): boolean {
    if (msg === 0) {
      return false;
    }

    return currentImage === this.lastImage;
  }

  updateLastImage(currentImage: string): void {
    this.lastImage = currentImage;
  }
}
